<template>
  <div class="p-4 md:p-6 lg:p-8 bg-app-bg-light dark:bg-app-bg-dark min-h-screen">
    <!-- Header -->
    <div class="flex items-center gap-3 mb-6">
      <button
        @click="$router.push('/inicio')"
        class="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400 hover:text-custom-primary dark:hover:text-custom-primary transition-colors border-0 bg-transparent"
      >
        <i class="bx bx-arrow-back text-lg"></i>
        Regresar
      </button>
      <div class="h-5 w-px bg-slate-300 dark:bg-slate-600"></div>
      <div>
        <h1 class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100">
          Libro de Servicios — {{ brand.nombre }}
        </h1>
        <p class="text-xs text-slate-500 dark:text-slate-400">NIT {{ brand.nit }} · Registro diario de ventas e ingresos (Hotel + Restaurante + Tienda)</p>
      </div>
    </div>

    <!-- Filtros -->
    <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm mb-6">
      <div class="flex flex-wrap gap-3 items-end">
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Mes</label>
          <select v-model="filtro.mes" class="form-control form-control-sm">
            <option v-for="m in meses" :key="m.val" :value="m.val">{{ m.label }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Año</label>
          <select v-model="filtro.anio" class="form-control form-control-sm">
            <option v-for="a in anios" :key="a" :value="a">{{ a }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Desde</label>
          <input type="date" v-model="filtro.fecha_inicio" class="form-control form-control-sm" />
        </div>
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Hasta</label>
          <input type="date" v-model="filtro.fecha_fin" class="form-control form-control-sm" />
        </div>
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Hora inicio</label>
          <input type="time" v-model="filtro.hora_inicio" class="form-control form-control-sm" />
        </div>
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Hora fin</label>
          <input type="time" v-model="filtro.hora_fin" class="form-control form-control-sm" />
        </div>
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Ordenar por</label>
          <select v-model="ordenar" class="form-control form-control-sm">
            <option value="fecha_asc">Fecha (más antigua)</option>
            <option value="fecha_desc">Fecha (más reciente)</option>
            <option value="total_desc">Total (mayor)</option>
            <option value="total_asc">Total (menor)</option>
          </select>
        </div>
        <button @click="cargar" class="btn btn-outline-secondary btn-sm">
          <i class="bx bx-search mr-1"></i> Filtrar
        </button>
        <button @click="exportarPDF" class="btn btn-outline-primary btn-sm">
          <i class="bx bx-file-pdf mr-1"></i> PDF
        </button>
        <button @click="exportarExcel" class="btn btn-outline-success btn-sm">
          <i class="bx bx-spreadsheet mr-1"></i> Excel
        </button>
      </div>
    </div>

    <!-- Tabla principal -->
    <div class="bg-white dark:bg-slate-800 rounded-xl shadow-sm overflow-hidden mb-6">
      <div class="overflow-x-auto">
        <table class="w-full text-xs md:text-sm">
          <thead>
            <tr class="bg-slate-50 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700">
              <th class="px-3 py-3 text-left font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Fecha</th>
              <th class="px-3 py-3 text-left font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Tipo Doc.</th>
              <th class="px-3 py-3 text-left font-semibold text-slate-700 dark:text-slate-300">No. Facturas</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Hospedaje<br><span class="text-custom-primary font-normal text-xs">(bruto)</span></th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Serv.<br><span class="text-custom-primary font-normal text-xs">INGUAT</span></th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Restaurante<br><span class="text-amber-500 font-normal text-xs">(bruto)</span></th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Otros<br><span class="text-teal-500 font-normal text-xs">(bruto)</span></th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">Total</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">I.V.A.</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">Efectivo</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">Transfer.</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">T. Crédito</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Crédito<br><span class="text-purple-500 font-normal text-xs">(por cobrar)</span></th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">Gastos</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Ret.IVA /<br>Exención</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Total a<br>Depositar</th>
              <th class="px-3 py-3 text-right font-semibold text-slate-700 dark:text-slate-300">Depositado</th>
              <th class="px-3 py-3 text-left font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap">Fecha Dep.</th>
              <th class="px-3 py-3 text-left font-semibold text-slate-700 dark:text-slate-300">No. Boleta</th>
              <th class="px-3 py-3 text-left font-semibold text-slate-700 dark:text-slate-300">Banco</th>
              <th class="px-3 py-3 text-center font-semibold text-slate-700 dark:text-slate-300">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="21" class="text-center py-10">
                <i class="bx bx-loader-alt bx-spin text-3xl text-custom-primary"></i>
              </td>
            </tr>
            <tr v-else-if="registros.length === 0">
              <td colspan="21" class="text-center py-10 text-slate-500 dark:text-slate-400">
                No hay pagos registrados para el período seleccionado.
              </td>
            </tr>
            <tr
              v-for="r in registrosOrdenados"
              :key="r.fecha"
              class="border-b border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors cursor-pointer"
              @click="abrirModal(r)"
            >
              <td class="px-3 py-2.5 text-slate-700 dark:text-slate-300 whitespace-nowrap font-medium">{{ formatFecha(r.fecha) }}</td>
              <td class="px-3 py-2.5 text-slate-600 dark:text-slate-400">{{ r.tipo_documento }}</td>
              <td class="px-3 py-2.5 text-slate-500 dark:text-slate-400 max-w-[120px] truncate" :title="r.numero_facturas">{{ r.numero_facturas || '—' }}</td>
              <td class="px-3 py-2.5 text-right text-slate-700 dark:text-slate-300 font-mono">{{ fmt(r.ventas_hospedaje_bruto) }}</td>
              <td class="px-3 py-2.5 text-right text-slate-700 dark:text-slate-300 font-mono">{{ fmt(r.servicios_inguat_bruto) }}</td>
              <td class="px-3 py-2.5 text-right text-amber-600 dark:text-amber-400 font-mono">{{ fmt(r.restaurante_bruto) }}</td>
              <td class="px-3 py-2.5 text-right text-teal-600 dark:text-teal-400 font-mono">{{ fmt(r.otros_bruto) }}</td>
              <td class="px-3 py-2.5 text-right font-semibold text-slate-800 dark:text-slate-100 font-mono">{{ fmt(r.total) }}</td>
              <td class="px-3 py-2.5 text-right text-yellow-600 dark:text-yellow-400 font-mono">{{ fmt(r.iva) }}</td>
              <td class="px-3 py-2.5 text-right text-green-600 dark:text-green-400 font-mono">{{ fmt(r.efectivo) }}</td>
              <td class="px-3 py-2.5 text-right text-purple-600 dark:text-purple-400 font-mono">{{ fmt(r.transferencias) }}</td>
              <td class="px-3 py-2.5 text-right text-blue-600 dark:text-blue-400 font-mono">{{ fmt(r.tarjeta_credito) }}</td>
              <td class="px-3 py-2.5 text-right text-purple-600 dark:text-purple-400 font-mono">{{ r.credito > 0 ? fmt(r.credito) : '—' }}</td>
              <td class="px-3 py-2.5 text-right text-red-500 dark:text-red-400 font-mono">{{ r.gastos > 0 ? fmt(r.gastos) : '—' }}</td>
              <td class="px-3 py-2.5 text-right text-orange-500 dark:text-orange-400 font-mono">{{ r.retencion_iva_exencion > 0 ? fmt(r.retencion_iva_exencion) : '—' }}</td>
              <td class="px-3 py-2.5 text-right font-bold text-custom-primary font-mono">{{ fmt(r.total_depositar) }}</td>
              <td class="px-3 py-2.5 text-right font-mono"
                :class="r.depositado > 0 && r.depositado >= r.total_depositar
                  ? 'text-green-600 dark:text-green-400'
                  : r.depositado > 0 ? 'text-yellow-600' : 'text-slate-400 dark:text-slate-500'">
                {{ r.depositado > 0 ? fmt(r.depositado) : '—' }}
              </td>
              <td class="px-3 py-2.5 text-slate-600 dark:text-slate-400 whitespace-nowrap">{{ r.fecha_deposito ? formatFecha(r.fecha_deposito) : '—' }}</td>
              <td class="px-3 py-2.5 text-slate-600 dark:text-slate-400">{{ r.numero_boleta || '—' }}</td>
              <td class="px-3 py-2.5 text-slate-600 dark:text-slate-400">{{ r.banco || '—' }}</td>
              <td class="px-3 py-2.5 text-center" @click.stop>
                <span v-if="r.guardado" @click="abrirModal(r)"
                  class="inline-flex items-center gap-1 text-xs text-green-600 dark:text-green-400 font-medium cursor-pointer hover:underline">
                  <i class="bx bx-check-circle"></i> Guardado
                </span>
                <span v-else @click="abrirModal(r)"
                  class="inline-flex items-center gap-1 text-xs text-amber-500 font-medium cursor-pointer hover:underline">
                  <i class="bx bx-pencil"></i> Pendiente
                </span>
                <button v-if="r.guardado" @click.stop="eliminar(r.id)" class="ml-2 text-red-400 hover:text-red-600 border-0 bg-transparent p-0">
                  <i class="bx bx-trash text-lg"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="registros.length > 0">
            <tr class="bg-slate-100 dark:bg-slate-900 font-bold text-slate-800 dark:text-slate-100 border-t-2 border-slate-300 dark:border-slate-600">
              <td colspan="3" class="px-3 py-3 text-sm">TOTALES</td>
              <td class="px-3 py-3 text-right font-mono text-sm">{{ fmt(totales.ventas_hospedaje_bruto) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm">{{ fmt(totales.servicios_inguat_bruto) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-amber-600 dark:text-amber-400">{{ fmt(totales.restaurante_bruto) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-teal-600 dark:text-teal-400">{{ fmt(totales.otros_bruto) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm">{{ fmt(totales.total) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-yellow-600 dark:text-yellow-400">{{ fmt(totales.iva) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-green-600 dark:text-green-400">{{ fmt(totales.efectivo) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-purple-600 dark:text-purple-400">{{ fmt(totales.transferencias) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-blue-600 dark:text-blue-400">{{ fmt(totales.tarjeta_credito) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-purple-600 dark:text-purple-400">{{ fmt(totales.credito) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-red-500">{{ fmt(totales.gastos) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-orange-500">{{ fmt(totales.retencion_iva_exencion) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm text-custom-primary">{{ fmt(totales.total_depositar) }}</td>
              <td class="px-3 py-3 text-right font-mono text-sm">{{ fmt(totales.depositado) }}</td>
              <td colspan="6"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- ── Modal Ajustes del día ─────────────────────────────────────────────── -->
    <div v-if="modal.visible" class="fixed inset-0 z-[500] flex items-center justify-center bg-black/50 p-4">
      <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-2xl max-h-[92vh] overflow-y-auto">
        <div class="flex items-center justify-between p-5 border-b border-slate-200 dark:border-slate-700">
          <div>
            <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100">
              {{ modal.guardado ? 'Editar ajustes' : 'Registrar ajustes' }} — {{ formatFecha(modal.row.fecha) }}
            </h2>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
              Los montos de ventas se calculan automáticamente desde los pagos del sistema
            </p>
          </div>
          <button @click="cerrarModal" class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 border-0 bg-transparent text-2xl leading-none">&times;</button>
        </div>

        <!-- Resumen del día (solo lectura) -->
        <div class="p-5 border-b border-slate-200 dark:border-slate-700">
          <p class="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-3">Ventas del día (calculado del sistema)</p>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-3">
              <p class="text-xs text-slate-500 dark:text-slate-400">Hospedaje</p>
              <p class="text-base font-bold text-slate-800 dark:text-slate-100">Q{{ fmt(modal.row.ventas_hospedaje_bruto) }}</p>
            </div>
            <div class="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3">
              <p class="text-xs text-amber-600 dark:text-amber-400">Restaurante</p>
              <p class="text-base font-bold text-amber-700 dark:text-amber-300">Q{{ fmt(modal.row.restaurante_bruto) }}</p>
            </div>
            <div class="bg-teal-50 dark:bg-teal-900/20 rounded-lg p-3">
              <p class="text-xs text-teal-600 dark:text-teal-400">Otros (tienda)</p>
              <p class="text-base font-bold text-teal-700 dark:text-teal-300">Q{{ fmt(modal.row.otros_bruto) }}</p>
            </div>
            <div class="bg-custom-primary/10 dark:bg-custom-primary/20 rounded-lg p-3">
              <p class="text-xs text-custom-primary">Total bruto</p>
              <p class="text-base font-bold text-custom-primary">Q{{ fmt(modal.row.total) }}</p>
            </div>
            <div class="bg-green-50 dark:bg-green-900/20 rounded-lg p-3">
              <p class="text-xs text-green-600 dark:text-green-400">Efectivo</p>
              <p class="text-base font-bold text-green-700 dark:text-green-300">Q{{ fmt(modal.row.efectivo) }}</p>
            </div>
            <div class="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-3">
              <p class="text-xs text-purple-600 dark:text-purple-400">Transferencias</p>
              <p class="text-base font-bold text-purple-700 dark:text-purple-300">Q{{ fmt(modal.row.transferencias) }}</p>
            </div>
            <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
              <p class="text-xs text-blue-600 dark:text-blue-400">Tarjeta</p>
              <p class="text-base font-bold text-blue-700 dark:text-blue-300">Q{{ fmt(modal.row.tarjeta_credito) }}</p>
            </div>
            <div class="bg-violet-50 dark:bg-violet-900/20 rounded-lg p-3">
              <p class="text-xs text-violet-600 dark:text-violet-400">Crédito (por cobrar)</p>
              <p class="text-base font-bold text-violet-700 dark:text-violet-300">Q{{ fmt(modal.row.credito) }}</p>
            </div>
            <div class="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-3">
              <p class="text-xs text-yellow-600 dark:text-yellow-400">IVA 12%</p>
              <p class="text-base font-bold text-yellow-700 dark:text-yellow-300">Q{{ fmt(modal.row.iva) }}</p>
            </div>
          </div>
          <div v-if="modal.row.inguat_referencia > 0" class="mt-2 text-xs text-slate-500 dark:text-slate-400">
            <i class="bx bx-info-circle mr-1"></i>
            Ref. INGUAT (desde registros contables): Q{{ fmt(modal.row.inguat_referencia) }}
          </div>
          <div class="mt-2 text-xs text-slate-500 dark:text-slate-400" v-if="modal.row.numero_facturas">
            <i class="bx bx-receipt mr-1"></i>Facturas FEL: {{ modal.row.numero_facturas }}
          </div>
        </div>

        <form @submit.prevent="guardar" class="p-5">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

            <!-- Ajustes contables -->
            <div class="md:col-span-2">
              <p class="text-xs font-semibold text-custom-primary uppercase tracking-wider mb-2 border-b border-slate-200 dark:border-slate-700 pb-1">
                Ajustes contables
              </p>
            </div>

            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Tipo Documento</label>
              <select v-model="form.tipo_documento" class="form-control">
                <option value="Factura">Factura</option>
                <option value="Recibo">Recibo</option>
                <option value="Nota de Crédito">Nota de Crédito</option>
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Gastos</label>
              <input type="number" v-model.number="form.gastos" step="0.01" min="0" class="form-control" @input="calcularDepositar" />
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Ret. IVA / Exención IVA</label>
              <input type="number" v-model.number="form.retencion_iva_exencion" step="0.01" min="0" class="form-control" @input="calcularDepositar" />
            </div>

            <!-- Total a depositar (calculado) -->
            <div class="md:col-span-2 bg-custom-primary/10 dark:bg-custom-primary/20 rounded-lg p-3 flex items-center justify-between">
              <p class="text-sm text-custom-primary font-medium">Total a Depositar</p>
              <p class="text-xl font-bold text-custom-primary">Q{{ fmt(calcTotalDepositar) }}</p>
            </div>

            <!-- Datos del depósito -->
            <div class="md:col-span-2">
              <p class="text-xs font-semibold text-custom-primary uppercase tracking-wider mb-2 border-b border-slate-200 dark:border-slate-700 pb-1">
                Datos del Depósito Bancario
                <span class="text-xs font-normal text-slate-400 ml-2">— completar cuando se realice el depósito</span>
              </p>
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Monto Depositado</label>
              <input type="number" v-model.number="form.depositado" step="0.01" min="0" class="form-control" placeholder="0.00" />
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Fecha de Depósito</label>
              <input type="date" v-model="form.fecha_deposito" class="form-control" />
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">No. de Boleta</label>
              <input type="text" v-model="form.numero_boleta" class="form-control" placeholder="Ej: 123456789" />
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Banco</label>
              <select v-model="form.banco" class="form-control">
                <option value="">Seleccione...</option>
                <option value="Banrural">Banrural</option>
                <option value="BAC Credomatic">BAC Credomatic</option>
                <option value="Industrial">Industrial</option>
                <option value="G&T Continental">G&T Continental</option>
                <option value="Agromercantil">Agromercantil</option>
                <option value="Otro">Otro</option>
              </select>
            </div>
            <div class="md:col-span-2">
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">No. de Facturas / DTE (manual)</label>
              <textarea v-model="form.numero_facturas" rows="2" class="form-control" placeholder="Se detecta automáticamente desde FEL. Completa si hay facturas manuales adicionales."></textarea>
            </div>
            <div class="md:col-span-2">
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Observaciones</label>
              <textarea v-model="form.observaciones" rows="2" class="form-control" placeholder="Servicios del día, notas..."></textarea>
            </div>
          </div>

          <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-slate-200 dark:border-slate-700">
            <button type="button" @click="cerrarModal" class="btn btn-outline-secondary">Cancelar</button>
            <button type="submit" :disabled="guardando" class="btn text-white" style="background:#B39659; border-color:#B39659;">
              <i class="bx bx-loader-alt bx-spin mr-1" v-if="guardando"></i>
              {{ guardando ? 'Guardando...' : (modal.guardado ? 'Actualizar' : 'Guardar Registro') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../../config/config.js';
import { BRAND } from '@/config/branding';

const formVacio = () => ({
  fecha: '',
  tipo_documento: 'Factura',
  numero_facturas: '',
  gastos: 0,
  retencion_iva_exencion: 0,
  depositado: 0,
  fecha_deposito: '',
  numero_boleta: '',
  banco: '',
  observaciones: '',
});

export default {
  name: 'IngresosDiarios',
  data() {
    const hoy = new Date();
    return {
      brand: BRAND,
      loading: false,
      guardando: false,
      registros: [],
      totales: {},
      filtro: {
        mes:          hoy.getMonth() + 1,
        anio:         hoy.getFullYear(),
        fecha_inicio: '',
        fecha_fin:    '',
        hora_inicio:  '00:00',
        hora_fin:     '23:59',
      },
      ordenar: 'fecha_asc',
      modal: { visible: false, guardado: false, id: null, row: {} },
      form: formVacio(),
      meses: [
        { val: 1, label: 'Enero' }, { val: 2, label: 'Febrero' }, { val: 3, label: 'Marzo' },
        { val: 4, label: 'Abril' }, { val: 5, label: 'Mayo' }, { val: 6, label: 'Junio' },
        { val: 7, label: 'Julio' }, { val: 8, label: 'Agosto' }, { val: 9, label: 'Septiembre' },
        { val: 10, label: 'Octubre' }, { val: 11, label: 'Noviembre' }, { val: 12, label: 'Diciembre' },
      ],
      anios: Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i),
    };
  },
  computed: {
    registrosOrdenados() {
      const arr = [...this.registros];
      switch (this.ordenar) {
        case 'fecha_desc': return arr.sort((a, b) => b.fecha.localeCompare(a.fecha));
        case 'total_desc': return arr.sort((a, b) => b.total - a.total);
        case 'total_asc':  return arr.sort((a, b) => a.total - b.total);
        default:           return arr.sort((a, b) => a.fecha.localeCompare(b.fecha));
      }
    },
    calcTotalDepositar() {
      const row = this.modal.row || {};
      return parseFloat((
        (row.efectivo || 0) +
        (row.transferencias || 0) +
        (row.tarjeta_credito || 0) -
        (this.form.gastos || 0) -
        (this.form.retencion_iva_exencion || 0)
      ).toFixed(2));
    },
  },
  methods: {
    fmt(num) {
      return new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num ?? 0);
    },
    formatFecha(f) {
      if (!f) return '—';
      const d = new Date(f.substring(0, 10) + 'T12:00:00');
      return d.toLocaleDateString('es-GT', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    calcularDepositar() {
      // Trigger computed recalculation (noop — computed handles it)
    },
    async cargar() {
      try {
        this.loading = true;
        const params = {};
        if (this.filtro.fecha_inicio) {
          params.fecha_inicio = this.filtro.fecha_inicio;
          params.fecha_fin    = this.filtro.fecha_fin;
        } else {
          params.mes  = this.filtro.mes;
          params.anio = this.filtro.anio;
        }
        params.hora_inicio = this.filtro.hora_inicio;
        params.hora_fin    = this.filtro.hora_fin;
        const { data } = await axios.get(`${API_URL}/contabilidad/ingresos-diarios`, { params });
        this.registros = data.registros;
        this.totales   = data.totales;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // ── Modal ──────────────────────────────────────────────────────────────────
    abrirModal(r) {
      this.modal = {
        visible:  true,
        guardado: r.guardado,
        id:       r.id,
        row:      r,
      };
      this.form = {
        fecha:                   r.fecha,
        tipo_documento:          r.tipo_documento || 'Factura',
        numero_facturas:         r.numero_facturas || '',
        gastos:                  r.gastos || 0,
        retencion_iva_exencion:  r.retencion_iva_exencion || 0,
        depositado:              r.depositado || 0,
        fecha_deposito:          (r.fecha_deposito || '').substring(0, 10),
        numero_boleta:           r.numero_boleta || '',
        banco:                   r.banco || '',
        observaciones:           r.observaciones || '',
      };
    },
    cerrarModal() {
      this.modal = { visible: false, guardado: false, id: null, row: {} };
      this.form  = formVacio();
    },
    async guardar() {
      try {
        this.guardando = true;
        if (this.modal.guardado) {
          await axios.put(`${API_URL}/contabilidad/ingresos-diarios/${this.modal.id}`, this.form);
        } else {
          await axios.post(`${API_URL}/contabilidad/ingresos-diarios`, this.form);
        }
        this.cerrarModal();
        await this.cargar();
      } catch (e) {
        console.error(e);
        alert('Error al guardar. Verifique los datos.');
      } finally {
        this.guardando = false;
      }
    },
    async eliminar(id) {
      if (!confirm('¿Eliminar los ajustes de este día?')) return;
      try {
        await axios.delete(`${API_URL}/contabilidad/ingresos-diarios/${id}`);
        await this.cargar();
      } catch (e) {
        console.error(e);
      }
    },

    // ── Exportar PDF ──────────────────────────────────────────────────────────
    async exportarPDF() {
      try {
        const params = {};
        if (this.filtro.fecha_inicio) {
          params.fecha_inicio = this.filtro.fecha_inicio;
          params.fecha_fin    = this.filtro.fecha_fin;
        } else {
          params.mes  = this.filtro.mes;
          params.anio = this.filtro.anio;
        }
        params.hora_inicio = this.filtro.hora_inicio;
        params.hora_fin    = this.filtro.hora_fin;
        params.ordenar     = this.ordenar;
        const response = await axios.get(`${API_URL}/contabilidad/ingresos-diarios/pdf`, {
          params,
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `libro-servicios-hotel-${params.mes || params.fecha_inicio}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
      } catch (e) {
        if (e.response?.data instanceof Blob) {
          const text = await e.response.data.text();
          try {
            const json = JSON.parse(text);
            alert(json.error || json.message || 'Error al generar el PDF.');
          } catch { alert('Error al generar el PDF.'); }
        } else {
          console.error(e);
          alert('Error al generar el PDF.');
        }
      }
    },

    // ── Exportar Excel ────────────────────────────────────────────────────────
    exportarExcel() {
      var BOM = '\uFEFF';
      var numFmt = function(n) { return (parseFloat(n) || 0).toFixed(2); };
      var esc = function(v) {
        var s = String(v ?? '');
        if (s.indexOf(',') !== -1 || s.indexOf('"') !== -1 || s.indexOf('\n') !== -1) {
          return '"' + s.replace(/"/g, '""') + '"';
        }
        return s;
      };
      var rowToLine = function(arr) { return arr.map(esc).join(';'); };
      var t = this.totales || {};
      var mesMes = this.meses.find(function(m) { return m.val === this.filtro.mes; }, this);
      var mesLabel = mesMes ? mesMes.label : '';
      var lines = [
        'LIBRO DE SERVICIOS - ' + BRAND.nombre.toUpperCase() + ' - NIT ' + BRAND.nit,
        'Periodo: ' + mesLabel + ' ' + this.filtro.anio,
        '',
        rowToLine([
          'Fecha','Tipo Doc.','No. Facturas',
          'V. Hospedaje Bruto','Serv. INGUAT Bruto','Restaurante Bruto','Otros Bruto',
          'V. Hospedaje (base)','Serv. INGUAT (base)','Restaurante (base)','Otros (base)',
          'Total','IVA',
          'Efectivo','Transferencias','Tarjeta Credito','Credito (por cobrar)',
          'Gastos','Ret.IVA/Exencion','Total a Depositar','Depositado',
          'Fecha Deposito','No. Boleta','Banco','Observaciones',
        ]),
      ];
      this.registros.forEach(function(r) {
        lines.push(rowToLine([
          (r.fecha || '').substring(0, 10),
          r.tipo_documento || '',
          r.numero_facturas || '',
          numFmt(r.ventas_hospedaje_bruto),
          numFmt(r.servicios_inguat_bruto),
          numFmt(r.restaurante_bruto),
          numFmt(r.otros_bruto),
          numFmt(r.ventas_hospedaje),
          numFmt(r.servicios_inguat),
          numFmt(r.restaurante),
          numFmt(r.otros),
          numFmt(r.total),
          numFmt(r.iva),
          numFmt(r.efectivo),
          numFmt(r.transferencias),
          numFmt(r.tarjeta_credito),
          numFmt(r.credito),
          numFmt(r.gastos),
          numFmt(r.retencion_iva_exencion),
          numFmt(r.total_depositar),
          numFmt(r.depositado),
          (r.fecha_deposito || '').substring(0, 10),
          r.numero_boleta || '',
          r.banco || '',
          r.observaciones || '',
        ]));
      });
      lines.push(rowToLine([
        'TOTALES','','',
        numFmt(t.ventas_hospedaje_bruto), numFmt(t.servicios_inguat_bruto),
        numFmt(t.restaurante_bruto), numFmt(t.otros_bruto),
        numFmt(t.ventas_hospedaje), numFmt(t.servicios_inguat),
        numFmt(t.restaurante), numFmt(t.otros),
        numFmt(t.total), numFmt(t.iva),
        numFmt(t.efectivo), numFmt(t.transferencias), numFmt(t.tarjeta_credito), numFmt(t.credito),
        numFmt(t.gastos), numFmt(t.retencion_iva_exencion),
        numFmt(t.total_depositar), numFmt(t.depositado),
        '','','','',
      ]));
      var csv = lines.join('\r\n');
      var blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'libro-servicios-' + this.filtro.mes + '-' + this.filtro.anio + '.csv';
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
  mounted() {
    this.cargar();
  },
};
</script>
